export enum PAGINATION_STATUS {
  FROM,
  TO,
  TOTAL,
}

type PageData = {
  from: number;
  to: number;
  total: number;
};

export const generatePaginationMessage = (
  messageFormat: string,
  { from, to, total }: PageData,
): string => {
  const mapObject: any = {
    [PAGINATION_STATUS.FROM]: from,
    [PAGINATION_STATUS.TO]: to,
    [PAGINATION_STATUS.TOTAL]: total,
  };
  const objectRegex = new RegExp(Object.keys(mapObject).join('|'), 'gi');

  return messageFormat.replace(objectRegex, (matched: string) => {
    return mapObject[matched];
  });
};
